'use client'

import { ReactNode } from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { mtc, TypographyStyles } from '../../../utils/style-helpers'
import { Text } from '../text'
import { optionalTextStyles, titleStyles } from './styles'

export interface ILabelProps extends LabelPrimitive.LabelProps {
  children?: ReactNode
  className?: string
  disabled?: boolean
  error?: boolean
  optionalText?: string
  title?: string
}

export const Label = ({
  children,
  className,
  disabled,
  error,
  optionalText,
  title,
  ...props
}: ILabelProps) => {
  return (
    <LabelPrimitive.Root className={mtc(className)} {...props}>
      {(title || optionalText) && (
        <div className="mb-2">
          <Text
            className={mtc(titleStyles({ error, disabled }))}
            variant={TypographyStyles.LABEL_MD}
          >
            {title}
          </Text>

          {optionalText && (
            <Text
              className={mtc(optionalTextStyles({ error, disabled }))}
              variant={TypographyStyles.BODY_XS}
            >
              {optionalText}
            </Text>
          )}
        </div>
      )}

      {children}
    </LabelPrimitive.Root>
  )
}

Label.displayName = LabelPrimitive.Root.displayName
